import { create } from 'zustand'

// Use ReturnType to extract UserResource type from useUser hook
type UserResource = NonNullable<ReturnType<typeof import('@clerk/clerk-react').useUser>['user']>

interface AuthState {
  isSignedIn: boolean
  isLoading: boolean
  user: UserResource | null
  selectedBranchId: string | null
  selectedRestaurantId: string | null
  setAuthState: (isSignedIn: boolean, user: UserResource | null, isLoading: boolean) => void
  setSelectedBranchId: (branchId: string | null) => void
  setSelectedRestaurantId: (restaurantId: string | null) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  isSignedIn: false,
  isLoading: true,
  user: null,
  selectedBranchId: null,
  selectedRestaurantId: null,
  setAuthState: (isSignedIn, user, isLoading) =>
    set({ isSignedIn, user, isLoading }),
  setSelectedBranchId: (branchId) => set({ selectedBranchId: branchId }),
  setSelectedRestaurantId: (restaurantId) => set({ selectedRestaurantId: restaurantId }),
  clearAuth: () => set({
    isSignedIn: false,
    user: null,
    isLoading: false,
    selectedBranchId: null,
    selectedRestaurantId: null,
  }),
}))

